export class FleetAuthField {
    fleetAuthFieldName: string;
    tooltipText: string;
    modelField: string;
    isRequired: boolean;
    dataType: number;
    fleetAuthFieldValueId: number ;
    fleetAuthFieldValue:  string[] ;
    fleetAuthFieldId: number;
  }

  export class FleetAuthFields {
      fields: FleetAuthField[];
  }

  export class FleetAuth extends FleetAuthFields {
    quoteId: number;
    isAuthorised: boolean;
    isLocked: boolean;
    authStatus: string;
    stateId: number;
    merchantNumber: string;
    sfReference: string;
    authNumber: string;
    dtEmailed: Date;
    dtResponded: Date;
    emailAddresses: string;
    authLetterBase64: string;
    fitmentCentreDetails: string;
    salesManDetails: string;
    callCentreNumber: string;
    message: string;
    fleetProcessDocBase64: string | null;
    hasFleetProcessDoc?: boolean;
    fleetAuthType: number;
    fleetAuthSubType: number;
  }

  export class FleetAuthCheck extends FleetAuth {
    comment: string;
  }

  export class FleetAuthLetter {
    quoteId: number;
    authLetterBase64: string;
  }
  export class FleetAuthorisation{
    isAuthorised: boolean;
    stateId: number = 0;
    authNumber: string;
    message: string;
  }
